import { JsonSchemaViewer } from '@stoplight/json-schema-viewer'
import { JSONSchema } from '@stoplight/elements-core/types'
import { useParsedValue } from '@stoplight/elements-core'

const originalObjectSymbol = Symbol('OriginalObject')

type JsonSchemaComponentProps = {
  value: string
}

function isJSONSchema(value: object) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

function getOriginalObject(resolvedObject: object): object {
  // @ts-expect-error
  return resolvedObject[originalObjectSymbol] || resolvedObject
}

export const JsonSchemaComponent = ({ value }: JsonSchemaComponentProps) => {
  const parsedValue = useParsedValue(value) as JSONSchema

  if (!isJSONSchema(parsedValue)) {
    return null
  }

  return <JsonSchemaViewer schema={getOriginalObject(parsedValue)} />
}
